import moment from "moment";
export default {
    methods: {
       isExpiringSoon() {
           const ccInfo = moment(this.$store.state.ccInfo.exp,'MM/YYYY');
           const diff = ccInfo.diff(moment(),'months', true);
           return diff > -1 && diff <= 0;
        },
        isExpired() {
            return moment(this.$store.state.ccInfo.exp,'MM/YYYY').isBefore(moment(),'month')
        },
    }
}

